
import * as metahut_actions from './metahutActions';
import * as land_actions from './landActions';


let actions  = {...metahut_actions, ...land_actions};


export default actions;
